<!-- Brand Slider Start -->
<section class="cyclops brand-slider partners-section">
  <div class="container">

    <!-- Section Title -->
    <div class="row">
      <div class="col-12">
        <h2 class="section-title gradient-text text-center" style="color: #b70000;">Our Partners</h2>
      </div>
    </div>

    <!-- Slider -->
    <div class="row mt-4">
      <div class="col-12">
        <owl-carousel-o [options]="brandcarouselOptions">
          <ng-container *ngFor="let brand of brands">
            <ng-template carouselSlide class="item">
              <a href="javascript:void(0)">
                <img [src]="brand.img" alt="" class="img-fluid">
              </a>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>

  </div>
</section>

<!-- Brand Slider End -->
